import { Patient } from '@koi/components/DigitalForms/api/types/digitalForms.api.types';
import { PatientSex } from '@koi/components/DigitalForms/api/types/patient.types';
import { useCallback } from 'react';

export const usePatientSex = () => {
  const getPatientSex = useCallback((patient: Pick<Patient, 'sexId'>) => {
    switch (patient.sexId) {
      case PatientSex['Male neutered']:
        return 'MN';
      case PatientSex['Male']:
        return 'M';
      case PatientSex['Female spayed']:
        return 'FS';
      case PatientSex['Female']:
        return 'F';
      case PatientSex['Unknown']:
        return 'Unk';
    }
  }, []);

  const getFullPatientSex = useCallback((patient: Pick<Patient, 'sexId'>) => {
    switch (patient.sexId) {
      case PatientSex['Male neutered']:
        return 'Male neutered';
      case PatientSex['Male']:
        return 'Male';
      case PatientSex['Female spayed']:
        return 'Female spayed';
      case PatientSex['Female']:
        return 'Female';
      case PatientSex['Unknown']:
        return 'Unknown';
    }
  }, []);

  return { getPatientSex, getFullPatientSex };
};
